<div class="loading" *ngIf="applicationService.loadingSubject | async">
  <mat-spinner class="spinner" color="primary"></mat-spinner>
</div>
